import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import smoothScroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothScroll.polyfill();


import './scss/app.scss'
window.icons = require('./res/icons');
Vue.component('Unicon', require('./components/Unicon').default)
Vue.component('PrevNext', require('./components/PrevNext').default)
Vue.component('LangSwitch', require('./components/LangSwitch').default)
// Vue.component('BottomLeftLogo', require('./components/BottomLeftLogo').default)



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
